<!--
 * @Description: input 去掉前后空格、状态有 【，】
 disabled:可编辑，不可编辑
 view:true,false =>true:详情 false:不受控制
-->
<template>
  <div class="cos-form-item-detail cos-form-item-txtarea-detail" :style="{ minHeight: minH + 'px' }">
    <p :title="value">{{ value == null || value === '' ? '--' : value }}</p>
  </div>
</template>
<script lang="ts" setup>
import { ref, onMounted, useAttrs } from 'vue'
const attrs = useAttrs()
defineProps({
  value: {
    type: [String, Number]
  }
})
const minH = ref(52)
onMounted(() => {
  const autoSize: any = attrs.autoSize
  const row: any = attrs.row
  if (autoSize && autoSize.minRows) {
    minH.value = autoSize.minRows * 32 + 8
  }
  if (row) {
    minH.value = row * 32 + 8
  }
})
</script>
<script lang="ts">
export default { name: 'CosTextareaView' }
</script>
